import { useState } from "react";
import { ShieldAlert, KeyRound, RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Section } from "./Section";

export function SecretRotation({ t, open, onToggle }) {
  const [busy, setBusy] = useState("");

  const ACTIONS = [
    { key: "gateway-certs", label: t("Certyfikaty bramki VoIP"), desc: t("Regeneruje certyfikat TLS (self-signed / Let's Encrypt) i restartuje Asteriska."), danger: false },
    { key: "turn-pass", label: t("Hasło TURN"), desc: t("Losuje nowe hasło serwera TURN i ponownie wdraża konfigurację bramki."), danger: false },
    { key: "cron-secret", label: t("Sekret CRON (backupy)"), desc: t("Nowy token do zadań cron. Wpis crontab zostanie zaktualizowany automatycznie."), danger: false },
    { key: "jwt-secret", label: t("Sekret JWT (sesje)"), desc: t("Unieważnia wszystkie tokeny — WSZYSCY użytkownicy zostaną natychmiast wylogowani."), danger: true },
  ];

  const rotate = async (a) => {
    const warn = a.danger
      ? t("UWAGA: to natychmiast wyloguje wszystkich użytkowników (łącznie z Tobą). Kontynuować?")
      : t("Na pewno wykonać rotację?") + ` „${a.label}"?`;
    if (!window.confirm(warn)) return;
    setBusy(a.key);
    try {
      const { data } = await api.post(`/system/rotate/${a.key}`);
      toast.success(data.message || t("Gotowe"));
      if (a.key === "jwt-secret") {
        setTimeout(() => {
          try { localStorage.removeItem("fp_session"); } catch { /* ignore */ }
          window.location.reload();
        }, 2800);
      }
    } catch (e) {
      toast.error(formatApiError ? formatApiError(e) : t("Nie udało się wykonać rotacji"));
    } finally { setBusy(""); }
  };

  return (
    <Section icon={ShieldAlert} iconColor="text-red-400" title={t("Bezpieczeństwo — rotacja sekretów")}
      open={open} onToggle={onToggle} testid="settings-sec-secrets">
      <p className="text-[11px] text-slate-400 mb-3">
        {t("Odnów klucze i certyfikaty jednym kliknięciem, bez komend na serwerze. Zalecane po podejrzeniu wycieku.")}
      </p>
      <div className="space-y-2">
        {ACTIONS.map((a) => (
          <div key={a.key} data-testid={`secret-row-${a.key}`}
            className={`flex items-center gap-3 rounded-lg border p-3 ${a.danger ? "border-red-800/60 bg-red-950/20" : "border-slate-700 bg-slate-900/60"}`}>
            <div className="flex-1 min-w-0">
              <div className={`text-sm font-semibold ${a.danger ? "text-red-300" : "text-slate-200"}`}>{a.label}</div>
              <div className="text-[11px] text-slate-400 mt-0.5">{a.desc}</div>
            </div>
            <button type="button" onClick={() => rotate(a)} disabled={!!busy} data-testid={`secret-rotate-${a.key}`}
              className={`shrink-0 inline-flex items-center gap-1.5 rounded px-3 py-2 text-xs font-medium disabled:opacity-50 ${a.danger ? "bg-red-700 hover:bg-red-600 text-white" : "bg-slate-700 hover:bg-slate-600 text-slate-100"}`}>
              {busy === a.key ? <Loader2 size={13} className="animate-spin" /> : (a.danger ? <KeyRound size={13} /> : <RefreshCw size={13} />)}
              {t("Rotuj")}
            </button>
          </div>
        ))}
      </div>
    </Section>
  );
}
